import React, { useEffect, useState } from "react";
import { getUrlParams } from "../apiService/timespam";
import "./Theme.css";
import "./BannerPage.css";

const BannerPage = () => {
  const { theme, lang } = getUrlParams();
  const urlParams = new URLSearchParams(window.location.search);
  const bannerUrls = (urlParams.get("banners") || "").split(",").filter(Boolean);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  useEffect(() => {
    if (bannerUrls.length < 2) return;
    const timer = setInterval(() => {
      setCurrent((c) => (c + 1) % bannerUrls.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [bannerUrls.length]);

  if (bannerUrls.length === 0) return <div className="banner-empty" />;

  return (
    <section className="banner-page">
      <div className="banner-slider">
        {bannerUrls.map((src, i) => (
          <div key={i} className={`banner-slide ${i === current ? "banner-slide--active" : ""}`}>
            <img src={src} alt={`Banner ${i + 1}`} className="banner-img" />
          </div>
        ))}
        {bannerUrls.length > 1 && (
          <div className="banner-dots">
            {bannerUrls.map((_, i) => (
              <button
                key={i}
                className={`banner-dot ${i === current ? "banner-dot--active" : ""}`}
                onClick={() => setCurrent(i)}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default BannerPage;
